import apiSkobo from "@/helpers/api/apiSkobo";
import { SessionHelper } from "@/helpers/utilities/sessionHelper";

export const settings_actions = {
  async loadSettings() {
    if (!this.colorsState) {
      this.reloadSettings();
    }
  },

  async reloadSettings() {
    const response = await apiSkobo.get(`/Website/Layout`);
    this.setTheme(Object.values(response.data));
  },

  setTheme(settings) {
    settings.forEach(item => {
      if (item.typename.toLowerCase() === "colors") {
        if (!this.colorsState) {
          this.colorsState = {};
        }
        this.colorsState[item.key] = item.value;
      }

      if (item.typename.toLowerCase() === "customerdesign") {
        if (!this.customerDesignState) {
          this.customerDesignState = {};
        }
        this.customerDesignState[item.key] = item.value;
      }

      if (item.typename.toLowerCase() === "resellerdesign") {
        if (!this.resellerDesignState) {
          this.resellerDesignState = {};
        }
        this.resellerDesignState[item.key] = item.value;
      }
    });

    if (this.customerDesignState) {
      SessionHelper.addCustomerSystemLogo(this.customerDesignState["logo"]);
    }
  }
};

export const settings_getters = {
  colors: state => state.colorsState || {},
  customerDesign: state => state.customerDesignState || {},
  resellerDesign: state => state.resellerDesignState || {},

  colorSetup(state) {
    if (!state.colorsState) {
      return {
        "--color-tertiary-core": "#b4191e"
      };
    }

    const css = {};
    if (state.colorsState["color-primary-core"]) {
      css["--color-primary-core"] = state.colorsState["color-primary-core"];
    }

    if (state.colorsState["color-primary-light"]) {
      css["--color-primary-light"] = state.colorsState["color-primary-light"];
    }

    if (state.colorsState["color-primary-lightest"]) {
      css["--color-primary-lightest"] = state.colorsState["color-primary-lightest"];
    }

    if (state.colorsState["color-secondary-core"]) {
      css["--color-secondary-core"] = state.colorsState["color-secondary-core"];
    }

    if (state.colorsState["color-secondary-light"]) {
      css["--color-secondary-light"] = state.colorsState["color-secondary-light"];
    }

    if (state.colorsState["color-tertiary-core"]) {
      css["--color-tertiary-core"] = state.colorsState["color-tertiary-core"];
    }

    if (state.colorsState["color-danger"]) {
      css["--color-danger"] = state.colorsState["color-danger"];
    }

    if (state.colorsState["color-success"]) {
      css["--color-success"] = state.colorsState["color-success"];
    }
    return css;
  }
};

export const settings_state = {
  colorsState: null,
  customerDesignState: null,
  resellerDesignState: null,
  preservableStates: ["colorsState", "customerDesignState", "resellerDesignState"]
};
